import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { LenderStatistics } from '../../components/LenderStatistics';
import { LenderApplications } from '../../components/LenderApplications';
import s from './index.module.scss';

export const LenderView = () => {
  const { t } = useTranslation('dashboard');
  const { user } = useGetMe();

  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        <div className={s.content}>
          <h1 className={classnames(s.title, 'f-hero-h4 f-500')}>
            {user?.first_name
              ? t('dashboard_page.hey_user_welcome_back', { name: user.first_name })
              : t('dashboard_page.welcome_back')}
          </h1>
         <LenderStatistics />
         <LenderApplications />
        </div>
      </div>
    </div>
  );
};